import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLMenu, Icon, Table } from 'appSrc/components/UI';
import style from './styles/style.module.css';

class MissingFromDBTable extends PureComponent {
    render() {
        const { recordsMissingFromDB, openNewModal } = this.props;

        return (
            <div>
                <div className={ style.dataHeader }>Missing From Database (Active)</div>
                <Table>
                    <Table.Head>
                        <Table.Row>
                            <Table.Cell>AFFILIATE TYPE</Table.Cell>
                            <Table.Cell>ADVERTISER ID</Table.Cell>
                            <Table.Cell>ADVERTISER NAME</Table.Cell>
                            <Table.Cell>ACTIONS</Table.Cell>
                        </Table.Row>
                    </Table.Head>
                    <Table.Body>
                        { recordsMissingFromDB &&
                            recordsMissingFromDB.map( ( record, index ) => {
                                return (
                                    <Table.Row key={`${ record.affiliate }-${ record.advertiserId }-${index}`}>
                                        <Table.Cell>{ record.affiliate }</Table.Cell>
                                        <Table.Cell>{ record.advertiserId }</Table.Cell>
                                        <Table.Cell>{ record.advertiserName }</Table.Cell>
                                        <Table.Cell>
                                            <DLMenu
                                            icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                                            direction='left' >
                                                <DLMenu.Item text='Add To Database'
                                                onClick={ () => {
                                                    openNewModal( record, index );
                                                } }/>
                                            </DLMenu>
                                        </Table.Cell>
                                    </Table.Row>
                                );
                            } )
                        }
                    </Table.Body>
                </Table>
            </div>
        );
    }
}

export default connect()( MissingFromDBTable );
